import { Tooltip, tooltipClasses } from '@mui/material'
import type { TooltipProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import Info from '@mui/icons-material/Info'

const DarkTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#002C5F',
    color: '#ffffff',
    fontSize: 12,
    borderRadius: 6,
    padding: '8px 12px',
    boxShadow: '0px 4px 4px rgba(0,0,0,0.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#002C5F'
  }
})

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#ffffff',
    color: 'rgba(0,0,0,0.87)',
    fontSize: 12,
    borderRadius: 6,
    padding: '8px 12px',
    boxShadow: '0px 4px 8px rgba(0,0,0,0.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#ffffff'
  }
})

interface InfoTooltipProps {
  title: string
  iconSize?: number
  iconColor?: string
  variant?: 'dark' | 'light'
}

const InfoTooltip = ({ title, iconSize = 16, iconColor, variant = 'dark' }: InfoTooltipProps) => {
  const TooltipComponent = variant === 'light' ? LightTooltip : DarkTooltip
  return (
    <TooltipComponent title={title} arrow placement='bottom'>
      <Info sx={{ fontSize: iconSize, color: iconColor ?? '#002C5F', cursor: 'help' }} />
    </TooltipComponent>
  )
}

export default InfoTooltip
